export const SellAndRentSource = {
  SC_HOME: "โครงการ SC",
  EXTERNAL: "ทรัพย์สินนอกระบบ",
};

export const SellAndRentSourceEnum = {
  SC_HOME: "SC_HOME",
  EXTERNAL: "EXTERNAL",
};
